/**
 * PROTECTEDROUTE.JS — LOGIMES Platform
 * Role-based access control
 * Roles: super_admin > admin > user
 */

import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

// Redirect par role apres login
export const getRoleHome = (role) => {
  if (role === "super_admin") return "/super-admin";
  if (role === "admin")       return "/home";
  return "/home";
};

export default function ProtectedRoute({ allowedRoles = [] }) {
  const token = getCookie("token");
  const role  = getCookie("role");

  // Pas connecte → login
  if (!token) return <Navigate to="/" replace />;

  // Role pas autorise → page adaptee a son role
  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to={getRoleHome(role)} replace />;
  }

  return <Outlet />;
}
